import React, { useMemo } from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import ParameterWithSimpleInput from '../inputs/ParameterWithSimpleInput'
import ParameterWithSuperMultiAutocomplete from '../inputs/ParameterWithSuperMultiAutocomplete'
import ParameterWithSwitch from '../inputs/ParameterWithSwitch'
import { Stack } from '@mui/material'
import { shallowEqual, useSelector } from 'react-redux'
import { SeeOtherIconTooltip } from '../SeeIconTooltip'
import idDailyMinHelp from 'assets/pictures/observatory/idDailyMinHelp.webp'
import piezoValidOnlyHelp from 'assets/pictures/observatory/piezoValidOnlyHelp.webp'
import piezometryHorizonsHelp from 'assets/pictures/observatory/piezometryHorizonsHelp.webp'
import piezometryLimitHistoHelp from 'assets/pictures/observatory/piezometryLimitHistoHelp.webp'
import { INPUT_TYPES } from 'components/forms/SimpleInput'
import FrequencyDatas, { FREQUENCY_STATIONS_TYPES } from '../FrequencyDatas'
import { toUpper } from 'lodash'
import PiezoDataTypes from '../PiezoDataTypes'
import ShowDataTypesRules from '../ShowDataTypesRules'
import { usedUrl } from 'conf/basepath'
import { getQualifications } from 'utils/QualityUtils'

const PiezometryParameters = ({
    isWidget = false,
    isGlobal = false,
    defaultProps = {},
}) => {
    const {
        piezoDataTypes,
        piezometryDataTypes,
    } = useSelector(store => ({
        piezoDataTypes: store.StationReducer.piezoDataTypes,
        piezometryDataTypes: store.PiezometryReducer.piezometryDataTypes,
    }), shallowEqual)

    const formattedPiezoDataTypes = useMemo(() => piezoDataTypes.map(pdt => ({ ...pdt, displayedName: `${pdt.id} - ${pdt.name}` })), [piezoDataTypes])

    return (
        <Stack spacing={1.25}>
            {!isWidget && (
                <ParameterWithSuperMultiAutocomplete
                    {...defaultProps}
                    parameter='ID_MIN_JOURNALIER'
                    options={formattedPiezoDataTypes}
                    title={i18n.dailyMinId}
                    helpImage={idDailyMinHelp}
                    iconTooltip={
                        <SeeOtherIconTooltip
                            title={i18n.seeDataTypes}
                            link={`${usedUrl}#/piezometry/piezometryOptions`}
                        />
                    }
                    keyLabel='displayedName'
                />
            )}
            <ParameterWithSwitch
                {...defaultProps}
                parameter={isWidget ? 'piezoValidOnlyWidget' : 'piezoValidOnly'}
                title={i18n.validatedDataOnly}
                helpImage={piezoValidOnlyHelp}
            />
            <ParameterWithSuperMultiAutocomplete
                {...defaultProps}
                parameter='piezoQualificationType'
                options={getQualifications()}
                title={i18n.consideredQualificationType}
                keyValue='code'
                multiple
            />
            <ParameterWithSimpleInput
                {...defaultProps}
                parameter={isWidget ? 'piezometryHorizonsWidget' : 'piezometryHorizons'}
                title={i18n.chartHorizons}
                helpImage={piezometryHorizonsHelp}
                placeholder='7,30,90,365,HISTO'
            />
            <ParameterWithSimpleInput
                {...defaultProps}
                parameter={isWidget ? 'piezometryLimitHistoWidget' : 'piezometryLimitHisto'}
                title={i18n.chartHistoryLimit}
                helpImage={piezometryLimitHistoHelp}
                placeholder='265'
                type={INPUT_TYPES.int}
            />
            <FrequencyDatas module={isWidget ? null : toUpper(module.module)} stationType={FREQUENCY_STATIONS_TYPES.piezo} {...defaultProps} />
            {!isWidget && <ShowDataTypesRules link='piezometry/piezometryOptions' {...defaultProps} />}
            <PiezoDataTypes
                {...defaultProps}
                piezometryDataTypes={piezometryDataTypes}
                isGlobal={isGlobal}
            />
        </Stack>
    )
}

PiezometryParameters.propTypes = {
    isWidget: PropTypes.bool,
    isGlobal: PropTypes.bool,
    defaultProps: PropTypes.shape({}),
}

export default PiezometryParameters
